import React from "react";
import { observer } from "mobx-react";
import {
  ContentContainer,
  ErrorWrapper,
  EmptyWrapper,
  ScrollbarContainer,
} from "./Content.styled";
import RepairsOrdersItem from "../RepairsOrdersItemList/RepairsOrdersItemList";
import {
  Skeleton,
  Table,
  WidgetEmptyErrorPlaceholder,
  Scrollbar,
} from "@ann/web-components";

const headers = [
  { value: "vehicle", label: "Vehicle" },
  { value: "roNumber", label: "RO Number" },
  { value: "mileageIn", label: "Mileage In" },
  { value: "statusDescription", label: "Status" },
  { value: "appointment", label: "Appointment" },
  { value: "opened", label: "Opened" },
  { value: "closed", label: "Closed" },
  { value: "customerPay", label: "Customer Pay" },
  { value: "warrantyPay", label: "Warranty Pay" },
  { value: "totalRO", label: "Total RO" },
  { value: "serviceAdvisor", label: "Service Advisor" },
  { value: "lastService", label: "Last Service" },
];

const Content = observer(({ loading, error, isEmpty, orders, onRefresh }) => {
  const hasData = orders && orders.length > 0;

  if (loading) {
    return (
      <ContentContainer>
        <Skeleton height="420px" width="100%" />
      </ContentContainer>
    );
  }

  if (error) {
    return (
      <ContentContainer>
        <ErrorWrapper>
          <WidgetEmptyErrorPlaceholder
            icon="error"
            title="Something went wrong"
            message="We couldn't load your Repair Orders. Please try again."
            buttonText="Retry"
            showButton={true}
            onClick={onRefresh}
          />
        </ErrorWrapper>
      </ContentContainer>
    );
  }

  if (isEmpty || !hasData) {
    return (
      <ContentContainer>
        <EmptyWrapper>
          <WidgetEmptyErrorPlaceholder
            icon="build"
            title="No Repair Orders yet"
            message="You'll see service details here when work is created."
            showButton={false}
          />
        </EmptyWrapper>
      </ContentContainer>
    );
  }

  return (
    <ContentContainer>
      <Scrollbar size="medium">
        <ScrollbarContainer>
          <Table
            showActions={false}
            headers={headers}
            data={orders}
            mode="grid"
            gridColumns={1}
            gridNode={(item) => <RepairsOrdersItem info={item} />}
          />
        </ScrollbarContainer>
      </Scrollbar>
    </ContentContainer>
  );
});

export default Content;
